.chart > svg {
  background: var(--tractie-color-background-default);
}

.timeline-hours-bottom > .domain {
  stroke: var(--tractie-color-background-default);
}

.chart > svg .current-time {
  stroke: var(--tractie-color-content-default);
  stroke-width: 3;
  shape-rendering: crispEdges;
}

.day-label-backdrop {
  stroke: var(--tractie-color-background-default);
}

.timeline-hours-bottom > .tick > line {
  color: var(--tractie-color-border-emphasis);
}

.timeline-hours-bottom > .tick > text {
  font-size: 12px;
  color: var(--tractie-color-content-emphasis);
}

.timeline-hours > .domain {
  stroke: var(--tractie-color-background-default);
}

.timeline-hours > .tick > line {
  stroke: var(--tractie-color-border-default);
}

.timeline-hours > .tick > text {
  font-size: 12px;
  color: var(--tractie-color-content-emphasis);
}

.hour-scale > .tick > line {
  stroke: var(--tractie-color-border-default);
}

.day-line > .tick > line {
  stroke: var(--tractie-color-border-emphasis);
  stroke-width: 3px;
}

.tenminute-scale {
  stroke: var(--tractie-color-background-default);
  color: var(--tractie-color-border-default);
}

.swimLaneStyle {
  fill: var(--mwd-werklijn-color-background);
}

.wleVertrekLabelVlakje {
  fill: var(--tractie-color-background-default);
  stroke: var(--tractie-color-background-default);
}

.marginBackdropStyle {
  fill: var(--tractie-color-background-default);
}

.labelStylePrimary {
  color: var(--tractie-color-content-default-inverse);
  font-size: 0.875rem;
  font-weight: 700;
  fill: var(--tractie-color-content-default-inverse);
}

.labelStyleClaim {
  color: var(--tractie-color-content-default);
  font-size: 0.875rem;
  font-weight: 700;
  fill: var(--tractie-color-content-default);
}

.labelStyleDefectInzetbaar {
  color: var(--mwd-color-treintaak-text-defect-inzetbaar);
  font-size: 0.875rem;
  font-weight: 700;
  fill: var(--mwd-color-treintaak-text-defect-inzetbaar);
}

.labelStyleKorteInzet {
  color: var(--tractie-color-content-subtle);
  font-size: 0.875rem;
  font-weight: 700;
  fill: var(--tractie-color-content-subtle);
}

.labelIconStyle {
  fill: var(--tractie-color-content-default-inverse);
  position: absolute;
}

.werklijnElementenStyleBase {
  fill: var(--tractie-color-background-default);
  stroke: var(--tractie-color-background-default);
  outline: none;
  cursor: pointer;
}

.werklijnElementenStyleEmpty {
  fill: #fff;
  stroke: #4d4e51;
}

.werklijnElementenStyleManco {
  fill: var(--mwd-color-treintaak-background-manco);
  stroke: var(--mwd-color-treintaak-background-manco);
}

.werklijnElementenStylePlanned {
  fill: var(--mwd-color-treintaak-background-inzetbaar);
  stroke: var(--mwd-color-treintaak-background-inzetbaar);
}

.werklijnElementenStyleWrong {
  fill: var(--mwd-color-treintaak-background-verkeerd-mat);
  stroke: var(--mwd-color-treintaak-background-verkeerd-mat);
}

.werklijnElementenStyleMaintenance {
  fill: var(--mwd-color-maintenance);
  stroke: var(--mwd-color-maintenance);
}

.werklijnElementenStyleDefectNietInzetbaar {
  fill: var(--mwd-color-treintaak-background-defect-niet-inzetbaar);
  stroke: var(--mwd-color-treintaak-background-defect-niet-inzetbaar);
}

.werklijnElementenStyleDefectBeperktInzetbaar {
  fill: var(--mwd-color-treintaak-background-defect-beperkt-inzetbaar);
  stroke: var(--mwd-color-treintaak-background-defect-beperkt-inzetbaar);
}

.werklijnElementenStyleDefectInzetbaar {
  fill: var(--mwd-color-treintaak-background-defect-inzetbaar);
  stroke: var(--mwd-color-treintaak-background-defect-inzetbaar);
}

.werklijnElementenStyleOvergang {
  fill: transparent;
  stroke: transparent;
  outline: none;
  cursor: pointer;
}

.werklijnElementenStyleOvergangNoHover {
  fill: transparent;
  stroke: transparent;
  outline: none;
  cursor: pointer;
}

.werklijnElementenStyleOvergang:hover {
  fill: var(--tractie-color-background-hover);
}

.versterkt {
  stroke-width: 2;
}

.isClaimed {
  stroke-dasharray: 7, 3;
}

.werklijnLabelStyle {
  font-size: 0.875rem;
  fill: var(--tractie-color-content-default);
}

.werklijnLabelStyleInConflict {
  font-size: 0.875rem;
  fill: var(--mwd-color-treintaak-text-tijds-conflict);
  font-weight: 700;
}

.werklijnLabelStyleV2 {
  font-size: 0.875rem;
  fill: var(--tractie-color-content-default);
}

.werklijnLabelStyleV2InConflict {
  font-size: 0.875rem;
  fill: var(--mwd-color-treintaak-text-tijds-conflict);
  font-weight: 700;
}
